/**
 * Anchor a possibly-relative URL on the current origin.
 *
 * The API base is configured as a relative path (`/api/...`), which `fetch`
 * and image sources resolve fine — but a URL that is SHOWN to the user (or
 * copied) must be absolute to be useful outside the page.
 */
export function absoluteUrl(url: string): string {
  return new URL(url, window.location.origin).toString();
}
